import { render } from "./CollectCallQueueForm.vue?vue&type=template&id=a0aa8228"
import script from "./CollectCallQueueForm.vue?vue&type=script&lang=js"
export * from "./CollectCallQueueForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__